<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_390_81345)">
<path d="M20 11.5001L19.5 7.00012L18.05 7.95012C16.7 7.10012 15 6.50012 13.1 6.20012C13.1 6.20012 12.15 6.00012 10.9 6.00012C9.65 6.00012 8.5 6.15012 8.5 6.15012C3.65 6.75012 0 9.50012 0 12.8001C0 16.2001 3.75 19.0001 9.5 19.5001V17.5501C5.55 17.0001 3.05 15.1501 3.05 12.8001C3.05 10.6001 5.35 8.75012 8.5 8.15012C8.5 8.15012 10.95 7.60012 13.1 8.25012C14.15 8.50012 15.1 8.85012 15.9 9.35012L14 10.5001L20 11.5001Z" fill="#9E9E9E"/>
<path d="M9.49988 2.00006V19.5001L12.4999 18.0001V0.500061L9.49988 2.00006Z" fill="#FF9800"/>
</g>
<defs>
<clipPath id="clip0_390_81345">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
